module.exports = __webpack_public_path__ + "static/media/1.0eb4ff95.png";